import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import "./plugins/element";
import "./plugins/swiper";
import { EventBus } from "./plugins/bus";
import "./plugins/clipboard";
//css
import "./assets/css/component.css";
import "./assets/css/style.css"; 
import "./assets/css/layui.css"; 
import "./assets/css/public.css";
import "./assets/css/swiper.min.css";


import VideoPlayer from 'vue-video-player'
import headerTop from './components/public/header_new.vue'
import footer from './components/public/footer.vue'
Vue.component("header-view",headerTop);
Vue.component("footer-view",footer);
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)


import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({     
  easing: 'ease',  // 动画方式    
  speed: 500,  // 递增进度条的速度    
  showSpinner: false, // 是否显示加载ico    
  trickleSpeed: 200, // 自动递增间隔    
  minimum: 0.3 // 初始化时的最小百分比
})

Vue.prototype.$NProgress = NProgress


Vue.prototype.$Bus=EventBus;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
